export const MAINTENANCE_STATUS_IDS = ['pending', 'in_progress', 'completed', 'archived'];

export const MAINTENANCE_STATUS_COLUMNS = [
  {
    id: 'pending',
    label: 'Pending',
    shortLabel: 'Pending',
    color: '#F59E0B',
    bg: 'rgba(245,158,11,0.12)',
    border: 'rgba(245,158,11,0.35)',
  },
  {
    id: 'in_progress',
    label: 'In Progress',
    shortLabel: 'Doing',
    color: '#38BDF8',
    bg: 'rgba(56,189,248,0.12)',
    border: 'rgba(56,189,248,0.35)',
  },
  {
    id: 'completed',
    label: 'Completed',
    shortLabel: 'Done',
    color: '#10B981',
    bg: 'rgba(16,185,129,0.12)',
    border: 'rgba(16,185,129,0.35)',
  },
  {
    id: 'archived',
    label: 'Archived',
    shortLabel: 'Archived',
    color: '#94A3B8',
    bg: 'rgba(148,163,184,0.12)',
    border: 'rgba(148,163,184,0.35)',
  },
];

export const MAINTENANCE_STATUS_FILTER_OPTIONS = MAINTENANCE_STATUS_COLUMNS.map((c) => ({
  value: c.id,
  label: c.label,
}));

export const MAINTENANCE_STATUS_FORM_OPTIONS = MAINTENANCE_STATUS_COLUMNS.map((c) => ({
  value: c.id,
  label: c.label,
})).filter((option) => option.value !== 'archived');

export function resolveMaintenanceStatus(request) {
  if (request?.archived_at) return 'archived';
  const raw = String(request?.status ?? 'pending').toLowerCase();
  return MAINTENANCE_STATUS_IDS.includes(raw) ? raw : 'pending';
}

export function getMaintenanceStatusMeta(statusId) {
  const resolved = typeof statusId === 'object' ? resolveMaintenanceStatus(statusId) : statusId;
  return MAINTENANCE_STATUS_COLUMNS.find((c) => c.id === resolved) ?? MAINTENANCE_STATUS_COLUMNS[0];
}

export function maintenanceMatchesStatusFilter(request, filterValue) {
  if (!filterValue) return true;
  return resolveMaintenanceStatus(request) === filterValue;
}

const PRIORITY_RANK = { urgent: 0, high: 1, medium: 2, low: 3 };

/** Sort for Kanban cards: urgent first, then newest reported date. */
export function compareMaintenanceKanbanItems(a, b) {
  const pr = (PRIORITY_RANK[a.priority] ?? 4) - (PRIORITY_RANK[b.priority] ?? 4);
  if (pr !== 0) return pr;
  const ta = new Date(a.reported_date ?? a.created_at ?? 0).getTime();
  const tb = new Date(b.reported_date ?? b.created_at ?? 0).getTime();
  return tb - ta;
}
